import { Component, OnInit } from '@angular/core';
import {Page} from "./models/page";
import {PageService} from "./services/page.service";
import {NavigationExtras, Router} from "@angular/router";
declare var $ :any;
declare var bootbox: any;

@Component({
    selector: 'app-pagelist',
    template: `
<section class="content-header">
    <h1>
    {{ title }}
    </h1>
    <ol class="breadcrumb">
        <li><a href="#" routerLink="/home"><i class="fa fa-dashboard"></i> Dashboard</a></li>
        <li class="active">{{ title }}</li>
    </ol>
</section>
<section class="content">
    <div class="row">
        <div class="col-md-12">
        <div class="box box-solid">
            <div class="box-header with-border">
                <h3 class="box-title">{{ title }}</h3>
                <div class="pull-right">
                    <!-- <a href="#" routerLink="/pages/add" class="btn btn-md btn-success btn-flat">Add page</a> -->
                </div>
            </div>
            <!-- /.box-header -->
        <div class="box-body">
        
        <table class="table table-bordered" id="datatable" sortable-table (sorted)="onSorted($event)">
            <thead>
            <tr>
                <th style="width: 10px">#</th>
                <th sortable-column="Title" sort-direction="asc">Title</th>
                <th sortable-column="Description">Description</th>
                <th></th>
            </tr>
            </thead>
        
        <tbody>
        <tr *ngFor="let page of pagelist; let i=index">
        <td>{{ i + 1 }}</td>
        <td>{{ page.Title }}</td>
        <td>{{ page.Description }}</td>
        <td style="width: 100px;">
            <a href="#" class="btn btn-info btn-xs btn-flat" title="View" data-toggle="tooltip" routerLink="/pages/{{ page.PagesId }}" ><i class="fa fa-eye"></i></a>
            <a href="#" class="btn btn-primary btn-xs btn-flat" title="Edit" data-toggle="tooltip" routerLink="/pages/update/{{ page.PagesId }}"><i class="fa fa-pencil"></i></a>
            <!-- <button class="btn btn-danger btn-xs btn-flat" title="Delete" data-toggle="tooltip" (click)="deletePageConfirm(page.PagesId,i)"><i class="fa fa-times"></i></button> -->
        </td>
        </tr>
        </tbody>
        </table>
        </div>
        </div>
        </div>
    </div>
</section>
    `
})
export class PagelistComponent implements OnInit {
    title:string = "Pages";
    pagelist:Page[];

    constructor(
        private pageService:PageService,
        private router:Router,
    ) { }

    ngOnInit() {
        this.title;
        this.getPages({sortColumn: 'Title', sortDirection:'desc'});
    }
    
    onSorted($event){
        this.getPages($event);
    }

    getPages(criteria: PagesSearchCriteria) {        
        this.pageService.getPageList().then(data => {
            console.log("PAGE LIST =======>",data);
            this.pagelist = data['data']['data'];
            console.log("PAGES =======>",this.pagelist);       
            this.SortPages(criteria);     
        });
    }

    SortPages(criteria: PagesSearchCriteria): Pages[] {
        return this.pagelist.sort((a,b) => {
          if(criteria.sortDirection === 'desc'){
              console.log(a[criteria.sortColumn] < b[criteria.sortColumn])
            if (a[criteria.sortColumn] < b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
          else {
            console.log(a[criteria.sortColumn] > b[criteria.sortColumn])

            if (a[criteria.sortColumn] > b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
        });
    }

    deletePage(iPageId,i){
        this.pageService.deletePageCall(iPageId).then(data => {
            if(data['status'] === 200){
                $.toast({heading: 'Success', text: data['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.getPages({sortColumn: 'Title', sortDirection:'desc'});
            }else{
                $.toast({heading: 'Warning', text: data['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
        });
    }

    deletePageConfirm(iPageId,i){
        var _this = this;
        bootbox.confirm({
            message: "Are you sure you want to delete this record?",
            buttons: {
                confirm: {label: 'Yes',className: 'btn-success btn-flat'},
                cancel: {label: 'No',className: 'btn-default btn-flat'}
            },
            callback: function (result) {
                if(result) {
                    _this.deletePage(iPageId,i);
                }
            }
        });
    }
}

export class Pages {
    // id: string;
    Title: string;
    Description: string;
}
  
export class PagesSearchCriteria {
    sortColumn: string;
    sortDirection: string;
}


// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/pages/pagelist.component.ts